<template>
  <div class="router-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t('device.router.Return_to_router_list')}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100">
            <FormItem :label="$t('device.router.AnotherName')">
              <Input class="info" v-model="AnotherName" :placeholder="$t('device.router.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('device.router.name')">
              <Input class="info" v-model="name" disabled ></Input>
            </FormItem>
            <!-- <FormItem :label="$t('device.router.mod')">
              <Select class="info" v-model="linkType" :value="linkType">
                <Option :value="Number(0)" :key="Number(0)">{{$t('device.router.Internet')}}</Option>
                <Option :value="Number(1)" :key="Number(1)">{{$t('device.router.Lan')}}</Option>
              </Select>
            </FormItem> -->
            <FormItem :label="$t('device.router.channel')">
              <!-- <Input class="info" v-model="channel" :placeholder="$t('device.router.please_enter')"></Input> -->
              <Select class="info" v-model="channel" :value="channel">
                <Option v-for="i in ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']" :value="i" :key="i">{{ i }}</Option>
              </Select>
            </FormItem>
            <!-- <FormItem label="服务器地址">
              <Input class="info" v-model="serverAddr" placeholder="请输入"></Input>
            </FormItem> -->
            <FormItem :label="$t('device.router.remark')">
              <Input class="info" v-model="remark" :placeholder="$t('device.router.please_enter')"></Input>
            </FormItem>
            <hr>
            <br>
            <br>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t('device.router.save')}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'RouterEdit',
  data () {
    return {
      id: 0,
      name: '',
      linkType: 0,
      channel: 0,
      serverAddr: '',
      remark: '',
      AnotherName: ''
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('device.router.New_router') : this.$t('device.router.edit_router')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let channel = this.channel.charCodeAt(0)
      if (channel < 58) {
        channel = Number(channel - 48)
      } else {
        channel = Number(channel - 55)
      }
      let router = {
        id: this.id,
        name: this.name,
        linkType: this.linkType,
        channel: channel,
        serverAddr: this.serverAddr,
        remark: this.remark,
        AnotherName: this.AnotherName
      }
      Api.router.save(router).then(() => {
        this.$router.push({'name': 'RouterList'})
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    let id = to.params.id
    if (id !== 0) {
      Api.router.get(id).then(res => {
        let r = res.router
        next(vm => {
          vm.id = r.id
          vm.name = r.name
          vm.linkType = r.linkType
          if (r.channel < 10) {
            vm.channel = String.fromCharCode(r.channel + 48)
          } else {
            vm.channel = String.fromCharCode(r.channel + 55)
          }
          vm.serverAddr = r.serverAddr
          vm.remark = r.remark
          vm.AnotherName = r.AnotherName
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .router-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// edit.vue?2d6c1bf7